export default __webpack_public_path__ + "static/media/Treatment_SLEEK_MOIST_200_T.d82e67fc.png";